import React, { createContext, useMemo, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { bool, func } from 'prop-types';
import { Typography } from '@mui/material';
import { MDialog } from 'common';
import * as R from 'ramda';

// Create a context with default values
export const CreateCustomerAuthContext = createContext({
  controlType: 'GLOBAL',
  customerId: undefined,
});

export const initialStateStep1 = {
  address: undefined,
  address2: undefined,
  authorizationType: 'UNLIMITED',
  authorizationVolume: undefined,
  city: undefined,
  controlType: 'GLOBAL',
  customerClass: undefined,
  customerIdName: undefined,
  customerName: undefined,
  phoneNumber: undefined,
  renewalVolume: undefined,
  state: undefined,
  zipCode: undefined,
};
export const initialStateStep2 = {
  products: [],
  terminals: [],
};
export const initialStateStep3 = {
  controlNumbers: [],
};
export const initialStateStep4 = {
  carriers: [],
  isCarrierRestricted: 'false',
};

const Create = ({ isNavHidden, setIsNavHidden }) => {
  const navigate = useNavigate();

  const [info, setInfo] = useState({
    ...initialStateStep1,
    ...initialStateStep2,
    ...initialStateStep3,
    ...initialStateStep4,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [matching, setMatching] = useState([]);
  const [id, setId] = useState(R.defaultTo('', info.customerIdName));
  const [customerIdValidation, setCustomerIdValidation] = useState('');

  const context = useMemo(
    () => ({
      customerIdValidation,
      id,
      info,
      isNavHidden,
      matching,
      setCustomerIdValidation,
      setId,
      setInfo,
      setIsNavHidden,
      setMatching,
      setOpenDialog,
    }),
    [id, info, customerIdValidation, isNavHidden, matching, setIsNavHidden]
  );

  const handleClose = () => {
    setIsNavHidden(false);
    navigate('../');
  };

  return (
    <CreateCustomerAuthContext.Provider value={context}>
      <Outlet />
      <MDialog
        header="Unsaved Changes"
        leftButtonAction={() => setOpenDialog(false)}
        leftButtonText="Keep Editing"
        onClose={() => setOpenDialog(false)}
        open={openDialog}
        rightButtonAction={handleClose}
        rightButtonText="Continue"
      >
        <Typography color="textPrimary" component="span" variant="subtitle1">
          Are you sure you want to leave this page? You have unsaved authorization changes.
        </Typography>
      </MDialog>
    </CreateCustomerAuthContext.Provider>
  );
};

Create.propTypes = {
  isNavHidden: bool.isRequired,
  setIsNavHidden: func.isRequired,
};

export default Create;
